import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'

export default class GridItem extends React.Component {
  render() {
    const itemData = this.props.data
    return (
      <ScrollAnimation
        className="transable"
        animateIn="move-up"
        animateOnce={true}
        delay={200}
      >
        <div className="grid-item">
          <div
            className="grid-item-image"
            style={{
              backgroundImage: `url(${itemData.image.sizes.medium_large})`
            }}
          >
            <img src={itemData.logo.sizes.medium} alt="logo" />
          </div>
          <div className="grid-content">
            <h2>{itemData.title}</h2>
            <p dangerouslySetInnerHTML={{ __html: itemData.content }} />
          </div>
        </div>
      </ScrollAnimation>
    )
  }
}
